export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "delivery_collection_item": {
            "delivery_process_provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "delivery_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto"])}
          }
        }
      }
    }
  })
}